import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import { FaEye, FaPencilAlt, FaTrash } from 'react-icons/fa';

import SalesOrderAPI from '../../api/SalesOrderAPI';
import ApiUiController from '../../controller/ApiUiController';
import Display from '../../util/Display';
import Util from '../../util/Util';
import LeadConst from '../../util/LeadConst';
import Const from '../../util/Constants';

class InnerSalesOrderList extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).sales_order;
    this.state = { inApiCall: true, sales: [] };

    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() {
    SalesOrderAPI.getInnerList(this.props.type, this.props.id, this.onReceived, this.onFail);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.id !== this.props.id) {
      this.setState({ ...this.state, inApiCall: true, sales: [] });
      SalesOrderAPI.getInnerList(this.props.type, props.id, this.onReceived, this.onFail);
    }
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    if (this.props.onCount) {
      this.props.onCount('sales_order', res.count);
    }
    this.setState({ inApiCall: false, sales: res.data });
  };
  onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      SalesOrderAPI.delete(this.state.sales[indx].id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Sales Order deleted successfully', 'success');
    this.props.reload();
  };

  showList = () => this.state.sales.map((sale, _i) => (
    <tr key={`sale_${_i + 1}`}>
      <td>{sale.id}</td>
      <td>{Util.serverStringToDisplayDateTime(sale.start_date)}</td>
      <td>{Util.serverStringToDisplayDateTime(sale.end_date)}</td>
      <td>{Display.FieldValue(sale, 'probability', this.model.fields)}</td>
      <td>{Display.ModelLabelValue('user', sale.responsible_person)}</td>
      <td>{Display.FieldValue(sale, 'sales_person', this.model.fields)}</td>
      <td>{Display.FieldValue(sale, 'currency', this.model.fields)}</td>
      <td>{Display.FieldValue(sale, 'total', this.model.fields)}</td>
      {/* <td>{Display.ModelLabelValue('user', sale.created_by)}</td> */}
      {/* <td>{Display.FieldValue(sale, 'created_date', this.model.fields)}</td> */}
      <td>
        <span onClick={evnt => this.props.show(sale.id, LeadConst.SalesOrder)}
          className="buttons add buttons-sm">
          <FaEye /> Details
        </span>
        {this.Update &&
          <span onClick={evnt => this.props.edit(sale.id, LeadConst.SalesOrder)}
            className="buttons update buttons-sm">
            <FaPencilAlt /> Edit
          </span>
        }
        {this.Delete &&
          <span onClick={() => this.onDelete(_i)} className="buttons delete buttons-sm"><FaTrash /> Delete</span>
        }
      </td>
    </tr>
  ));

  render() {
    let uiSales = this.showList();
    if (this.state.sales.length === 0) uiSales = <tr><td colSpan="9">No Records Found</td></tr>;
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>Sales Order</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hove size='sm'>
              <thead>
                <tr><th>Id</th><th>Start Date</th><th>End Date</th><th>Probability</th><th>Sales Owner</th>
                  <th>Sales Person</th><th>Currency</th><th>Total</th>
                  <th className="actionth">Action</th></tr>
              </thead>
              <tbody>
                {uiSales}
              </tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default InnerSalesOrderList;